import { authHeader, handleResponse } from "../helpers";

export const affiliateProgramService = {
  list,
};

function list(params) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  let url = new URL(
    `${process.env.REACT_APP_API_URL}api/v1/affiliateProgram/list`
  );
  url.search = new URLSearchParams({
    offset: params.offset ?? 0,
    limit: params.limit ?? 10,
  });
  return fetch(url, requestOptions).then(handleResponse);
}
